import { render, staticRenderFns } from "./ProductTypeByCategoryModal.vue?vue&type=template&id=2a6a23a8&"
import script from "./ProductTypeByCategoryModal.vue?vue&type=script&lang=js&"
export * from "./ProductTypeByCategoryModal.vue?vue&type=script&lang=js&"
import style0 from "./ProductTypeByCategoryModal.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports